import { useMutation, useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { get, post } from '@/shared/api/client';
import { useSession } from '@/shared/api/session';
import { Badge, Button, Card, Table } from '@/shared/ui';
import { formatDateTime } from '@/shared/lib/format';
import { ChangePasswordPage } from './PasswordPages';

type S = { public_id: string; created_at: string; last_seen_at: string; ip_address: string | null; user_agent: string | null; current: boolean };

export function SecurityPage() {
  const { data: session } = useSession();
  const sessions = useQuery({ queryKey: ['auth', 'sessions'], queryFn: () => get<S[]>('/auth/sessions') });
  const revoke = useMutation({ mutationFn: () => post<void>('/auth/sessions/revoke-others'), onSuccess: () => sessions.refetch() });
  return (
    <>
      <h1 style={{ marginBottom: 'var(--sp-5)' }}>Seguridad</h1>
      <div style={{ display: 'grid', gap: 'var(--sp-4)', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', alignItems: 'start' }}>
        <ChangePasswordPage forced={false} />
        <Card title="Verificación en dos pasos (MFA)">
          <p style={{ fontSize: 'var(--fs-sm)' }}>Estado: {session?.mfa_enrolled ? <Badge tone="ok">Activa</Badge> : <Badge tone="pending">No configurada</Badge>}</p>
          {!session?.mfa_enrolled && <Link to="/auth/mfa/enroll"><Button variant="secondary">Configurar MFA</Button></Link>}
          {session?.mfa_enrolled && <p style={{ fontSize: 'var(--fs-xs)', color: 'var(--sgr-text-muted)' }}>Para reemplazar tu dispositivo, solicita un restablecimiento de MFA al administrador.</p>}
        </Card>
        <Card title="Sesiones activas" actions={<Button variant="secondary" size="sm" onClick={() => revoke.mutate()} loading={revoke.isPending}>Cerrar las demás</Button>}>
          <Table>
            <thead><tr><th>Inicio</th><th>Última actividad</th><th>IP</th><th></th></tr></thead>
            <tbody>{(sessions.data ?? []).map((x) => <tr key={x.public_id}><td>{formatDateTime(x.created_at)}</td><td>{formatDateTime(x.last_seen_at)}</td><td>{x.ip_address ?? '—'}</td><td>{x.current && <Badge tone="review">Esta sesión</Badge>}</td></tr>)}</tbody>
          </Table>
        </Card>
      </div>
    </>
  );
}
